// extracted by mini-css-extract-plugin
export var animationContainer = "_ga-0";
export var footer = "_ga-1";
export var gray = "_ga-2";
export var lineItem = "_ga-3";
export var lineItemImage = "_ga-4";
export var lineItemInfo = "_ga-5";
export var lineItemText = "_ga-6";
export var lineItems = "_ga-7";
export var modalContent = "_ga-8";
export var options = "_ga-9";
export var orderName = "_ga-a";
export var refundAmount = "_ga-b";